function generate(content) {
    return `<div></div>`
}

export default generate;